import React, { useState, useEffect, useRef } from 'react';
import Webcam from "react-webcam";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  Box,
  Image,
  Text,
  Spinner,
} from '@chakra-ui/react';

export default function WebCamDialog(props) {
  const webcamRef = useRef(null);
  const [devices, setDevices] = useState([]);
  const [imagedata, setImagedata,] = useState("");
  const [cameraReady, setCameraReady] = useState(false);
  const [captureURL, setCaptureURL] = useState(null);
  const [isCameraActive, setIsCameraActive] = useState(false);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices()
      .then(mediaDevices => {
        const videoDevices = mediaDevices.filter(({ kind }) => kind === "videoinput");
        setDevices(videoDevices);
        console.log("Available video devices:", videoDevices);
      });
  }, []);

  useEffect(() => {
    if (props.openWebCam) {
      setCaptureURL(null);
      setCameraReady(false);
      setIsCameraActive(true);
    }
  }, [props.openWebCam]);

  const handleCapture = () => {
    const imageSrc = webcamRef.current?.getScreenshot();
	console.log("imageSr111c",imageSrc)
    if (!imageSrc) return;

    setCaptureURL(imageSrc);
    setIsCameraActive(false);

    fetch(imageSrc)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], `${props.name || "photo"}.png`);
		console.log("file111",file)
		// setImagedata(file)
        const formData = new FormData();
		console.log("0007676",formData)
        formData.append('publicUpload', file);
        props.getImageUrl(formData,file);
		setImagedata(file);
      });
  };

  const handleRetake = () => {
	setCameraReady(false); // Reset so spinner shows
    setCaptureURL(null);
    setIsCameraActive(true);
  };
console.log("imagedata",imagedata)
  return (
    <Modal
      isOpen={props.openWebCam}
      onClose={props.handleCloseWebCam}
      isCentered
      motionPreset="none"
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Take a Photo</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box p={4} width="100%">
            {isCameraActive && (
              <>
                {!cameraReady && (
                  <Box textAlign="center" py={10}>
                    <Spinner size="lg" />
                    <Text mt={2}>Starting camera...</Text>
                  </Box>
                )}
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  screenshotFormat="image/png"
                  style={{ width: '100%', borderRadius: '8px' }}
                  videoConstraints={{
                    deviceId: devices[0]?.deviceId,
                  }}
                  onUserMedia={() => {
                    console.log("Camera ready");
                    setCameraReady(true);
                  }}
                  onUserMediaError={(err) => {
                    console.error("Camera access error:", err);
                  }}
                />
                {cameraReady && (
                  <Box textAlign="right" mt={2}>
                    <Button colorScheme="blue" size="sm" onClick={handleCapture}>
                      Click Your Picture
                    </Button>
                  </Box>
                )}
              </>
            )}

            {captureURL && !isCameraActive && (
              <Box mt={4} textAlign="center">
                <Image src={captureURL} alt="Captured" borderRadius="md" />
                <Button mt={2} colorScheme="orange" size="sm" onClick={handleRetake}>
                  Retake Photo
                </Button>
              </Box>
            )}

            {!isCameraActive && devices.length === 0 && (
              <Text color="red.500" textAlign="center">
                Camera not found. Please connect your camera.
              </Text>
            )}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}






